<script>
import {mapState} from "vuex";
import templatable from "@/mixins/templatable";

export default {
  name: "ErrorPageComponent",
  mixins: [templatable('errorPageTemplate')],
  data: () => ({
    template: `
      <div v-if="error.code" class="ta-page-error text-center" :class="error.code ? 'ta-error-' + error.code : '' ">
        [[template]]
      </div>
    `
  }),
  computed: {
    ...mapState(['error'])
  }
}
</script>

<style lang="scss" scoped>
</style>
